interface IBudgetAddServiceButtonsProps {
  onAddNewService: () => void;
  onAddExternalService: () => void;
}

const BudgetAddServiceButtons = (props: IBudgetAddServiceButtonsProps) => {
  return (
    <div className="px-6">
      <button
        type="button"
        className="btn btn-default m-4 ml-0"
        onClick={props.onAddNewService}
      >
        <img
          src="/assets/images/plusGreen.svg"
          alt="Van"
          className="w-5 h-5 flex-shrink-0 mx-2"
        />
        <span>Adicionar novo serviço ao orçamento</span>
      </button>

      <button
        type="button"
        className="btn text-gray-500 border-gray-200 border rounded-md m-4"
        onClick={props.onAddExternalService}
      >
        <img src="/assets/images/plus.svg" alt="Van" className="w-5 h-5 flex-shrink-0 mx-2" />
        <span>Adicionar serviço adicional / externo</span>
      </button>
    </div>
  );
};

export default BudgetAddServiceButtons;

